import React from "react";

interface CustomCodeRunnerProps {
  code: string;
  scope: Record<string, unknown>;
  label?: string;
}

/**
 * The single place a custom view's or widget's self-contained code is executed. The code is
 * compiled with `new Function`, receiving `React` followed by the provided scope values in order,
 * and rendered as a component. Errors thrown by the code are caught and surfaced inline so a bad
 * snippet shows a message instead of crashing the iframe.
 */
export default function CustomCodeRunner({ code, scope, label = "Error" }: CustomCodeRunnerProps) {
  try {
    const factory = new Function("React", ...Object.keys(scope), code);
    const Rendered = () => factory(React, ...Object.values(scope));
    return <Rendered />;
  } catch (err) {
    const message = err instanceof Error ? err.message : String(err);
    return <div className="widget-error">{label}: {message}</div>;
  }
}
